import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { action_options, app_modules } from "helpers/apps_modules_list";
import { fetchLatestPermissions } from "slices/auth/login/thunk";
// import { fetchUserDetails } from 'slices/auth/login/thunk';
// import type { AppDispatch } from "/src/index";

const Navdata = () => {
  // Permission section ============================
  const dispatch = useDispatch<any>();

  // Get user from Redux store with fallback to localStorage
  const reduxUser = useSelector((state: any) => state.Login.user);
  const [localUser, setLocalUser] = useState<any>(null);

  // Initialize user from localStorage if Redux doesn't have user data
  useEffect(() => {
    const initializeUser = () => {
      if (!reduxUser) {
        try {
          const authUser = localStorage.getItem("authUser");
          if (authUser) {
            setLocalUser(JSON.parse(authUser));
          } else {
            setLocalUser(null);
          }
        } catch (error) {
          console.error("Error parsing user data:", error);
          setLocalUser(null);
        }
      }
    };

    initializeUser();

    // Listen for localStorage changes (e.g., when user logs in/out in another tab)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "authUser") {
        initializeUser();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [reduxUser]);

  // Use Redux user if available, otherwise use localStorage user
  const user = reduxUser || localUser;

  // Fetch permissions
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        await dispatch(fetchLatestPermissions()).unwrap();
      } catch (error) {
        console.error("Failed to fetch latest permissions", error);
        // toast.error("Failed to fetch latest permissions");
      }
    };
    fetchPermissions();
  }, [dispatch]);

  const user_permissions = user?.permissions || [];

  const isAllUserManagementHavePermission = user_permissions?.find(
    (per: any) => per?.apps_name === app_modules?.user_management?.app_name
  );
  const isAllMasterHavePermission = user_permissions?.find(
    (per: any) => per?.apps_name === app_modules?.master?.app_name
  );

  // console.log(user_permissions, "user_permissions---------");

  function areAllPermissionsFalse(appObject: any) {
    // If no permission object exists, consider all permissions as false
    if (!appObject || !appObject.modules_permissions) {
      return true;
    }
    return appObject.modules_permissions.every(
      (module: any) =>
        !module.permissions.View &&
        !module.permissions.Create &&
        !module.permissions.Update
    );
  }

  // State data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isUserManagement, setIsUserManagement] = useState(false);
  const [isMasters, setIsMasters] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id: any = item.getAttribute("sub-items");
        var menusId = document.getElementById(id);
        if (menusId) {
          (menusId.parentElement as HTMLElement).classList.remove("show");
        }
      });
      e.target.classList.add("active");
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") setIsDashboard(false);
    if (iscurrentState !== "UserManagement") setIsUserManagement(false);
    if (iscurrentState !== "Masters") setIsMasters(false);
  }, [iscurrentState, isUserManagement, isDashboard, isMasters]);

  const menuItems: any = [
    {
      id: "dashboard",
      label: "Dashboard",
      link: "/dashboard",
      icon: "ph-chalkboard",
      activeUrl: ["/", "/dashboard"],
      permissions: {
        app_name: app_modules.dashboard.app_name,
        module_name: app_modules.dashboard.modules.dashboard,
        action: action_options?.view,
      },
    },

    !areAllPermissionsFalse(isAllUserManagementHavePermission) && {
      label: "User Management",
      isHeader: true,
    },
    {
      id: "userManagement",
      label: "User Management",
      icon: "ph-users",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsUserManagement(!isUserManagement);
        setIscurrentState("UserManagement");
        updateIconSidebar(e);
      },
      stateVariables: isUserManagement,
      subItems: [
        // {
        //   id: "organisations",
        //   label: "Organisation",
        //   icon: "ph-buildings",
        //   link: "/organisations-list",
        //   activeUrl: ["/organisation-form", "/edit-organisation/:id"],
        //   parentId: "userManagement",
        //   // permissions: { app_name: app_modules.user_management.app_name, module_name: app_modules?.user_management.modules.organisation, action: action_options?.view }
        // },
        // {
        //   id: "departments",
        //   label: "Department",
        //   icon: "ph-briefcase",
        //   link: "/department-list",
        //   activeUrl: ["/department-form", "/department-form/:id"],
        //   parentId: "userManagement",
        //   // permissions: { app_name: app_modules.user_management.app_name, module_name: app_modules?.user_management.modules?.department, action: action_options?.view }
        // },

        // {
        //   id: "teams",
        //   label: "Team",
        //   icon: "ph-users-three",
        //   link: "/team-list",
        //   activeUrl: ["/team-forms", "/team-forms/:id"],
        //   parentId: "userManagement",
        //   permissions: {
        //     app_name: app_modules.user_management.app_name,
        //     module_name: app_modules?.user_management.modules?.team,
        //     action: action_options?.view,
        //   },
        // },
        // {
        //   id: 13,
        //   label: "User Types",
        //   icon: "ph-user-circle",
        //   link: "/user-type",
        //   parentId: "master",
        //   activeUrl: ["/add-usertypes", "/add-usertypes/:id"],
        //   permissions: {
        //     app_name: app_modules.master.app_name,
        //     module_name: app_modules.master.modules.user_types,
        //     action: action_options?.view,
        //   },
        // },
        {
          id: "users",
          label: "User",
          icon: "ph-user-circle",
          link: "/user-list",
          activeUrl: ["/user-form", "/user-form/", "/user-details/:id"],
          parentId: "userManagement",
          permissions: {
            app_name: app_modules.user_management.app_name,
            module_name: app_modules?.user_management.modules?.user,
            action: action_options?.view,
          },
        },
        {
          id: "module",
          label: "Module",
          icon: "ph-user-circle",
          link: "/module-list",
          activeUrl: ["/module-form", "/user-form/", "/edit-module-form"],
          parentId: "userManagement",
          permissions: {
            app_name: app_modules.user_management.app_name,
            module_name: app_modules?.user_management.modules?.module,
            action: action_options?.view,
          },
        },
      ],
      permissions: {
        app_name: app_modules.user_management.app_name,
        module_name: app_modules.user_management.modules.user,
        action: action_options?.view,
      },

      // permissions: {app_name: app_modules.master.app_name, module_name: app_modules.master.modules.master, action: action_options?.view}
    },

    !areAllPermissionsFalse(isAllMasterHavePermission) && {
      label: "Masters",
      isHeader: true,
    },
    {
      id: "master",
      label: "Masters",
      icon: "ph-storefront",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsMasters(!isMasters);
        setIscurrentState("Masters");
        updateIconSidebar(e);
      },
      stateVariables: isMasters,
      subItems: [
        {
          id: 5,
          label: "Attributes",
          link: "/attribute",
          parentId: "master",
          activeUrl: [
            "/attribute-form",
            "/attribute-config-form/:id",
            "/attribute-form-edit/:id",
            "/config-attribute-form-edit/:id",
            "/config-attribute-form/:id",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.attribute,
            action: action_options?.view,
          },
        },
        {
          id: 6,
          label: "Category",
          link: "/category",
          parentId: "master",
          activeUrl: [
            "/add-category",
            "/category-view/:id",
            "/edit-category/:id",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.category,
            action: action_options?.view,
          },
        },
        {
          id: 6.5,
          label: "Brand",
          link: "/brand",
          parentId: "master",
          activeUrl: ["/add-brand", "/brand-details/:id", "/edit-brand/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.brand,
            action: action_options?.view,
          },
        },
        {
          id: 7,
          label: "GST",
          link: "/gst",
          parentId: "master",
          activeUrl: ["/add-gst", "/edit-gst/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.gst,
            action: action_options?.view,
          },
        },
        {
          id: 8,
          label: "HSN Code",
          link: "/hsn-codes",
          parentId: "master",
          activeUrl: ["/add-hsn-code", "/edit-hsn-code/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.hsn_code,
            action: action_options?.view,
          },
        },
        {
          id: 9,
          label: "Tags",
          link: "/tag",
          parentId: "master",
          activeUrl: ["/add-tag", "/edit-tag/:id"],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.tag,
            action: action_options?.view,
          },
        },
        {
          id: 10,
          label: "Item",
          link: "/item",
          parentId: "master",
          activeUrl: [
            "/add-item",
            "/edit-item/:id",
            "/view-details/:id",
            "/web-sync-log",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.item,
            action: action_options?.view,
          },
        },
        {
          id: 11,
          label: "Customer/Company",
          link: "/customer",
          parentId: "master",
          activeUrl: [
            "/add-customer",
            "/edit-customer/:id",
            "/view-customer/:id",
          ],
          permissions: {
            app_name: app_modules.master.app_name,
            module_name: app_modules.master.modules.customer,
            action: action_options?.view,
          },
        },
      ],
      permissions: {
        app_name: app_modules.master.app_name,
        module_name: app_modules.master.modules.master,
        action: "allowed",
      },
    },

    //*// Template sidemenu
    {
      id: "template",
      label: "Template",
      link: "/template",
      icon: "ph-layout",
      activeUrl: ["/add-template", "/edit-template/:id", "/view-template/:id"],
      permissions: {
        app_name: app_modules.template.app_name,
        module_name: app_modules.template.modules.template,
        action: action_options?.view,
      },
    },

    // *// Quatation sidemenu
    {
      id: "quotation",
      label: "Quotation",
      link: "/quotation",
      icon: "ph-clipboard-text",
      // icon: "ph-invoice",
      activeUrl: [
        "/add-quotation",
        "/edit-quotation/:id",
        "/view-quotation/:id",
        "/view-trash-quotation/:id",
      ],
      permissions: {
        app_name: app_modules.quotation.app_name,
        module_name: app_modules.quotation.modules.quotation,
        action: action_options?.view,
      },
    },
  ];

  const hasPermission = (
    app_name: string,
    module_name: string,
    permission: string
  ): boolean => {
    return user_permissions?.some(
      (app: any) =>
        app.apps_name === app_name &&
        app.modules_permissions?.some(
          (module: any) =>
            module.modules_name === module_name &&
            module.permissions?.[permission] === true
        )
    );
  };

  const filterItemsWithPermissions = (items: any[]): any[] => {
    return items
      .map((item: any) => {
        if (item.subItems?.length) {
          const filteredSubItems = filterItemsWithPermissions(item.subItems);

          if (filteredSubItems.length) {
            return { ...item, subItems: filteredSubItems };
          }
          return null;
        }
        if (item.permissions) {
          const { app_name, module_name, action } = item.permissions;
          return hasPermission(app_name, module_name, action) ? item : null;
        }
        // If no permissions are defined, include the item (for headers, etc.)
        return item;
      })
      .filter(Boolean);
  };

  // Filter out false values first, then apply permissions filter
  const validMenuItems = menuItems.filter(Boolean);
  const filteredMenuItems = filterItemsWithPermissions(validMenuItems);
  // const filteredMenuItems = validMenuItems;
  // console.log("Menu items before filtering:", validMenuItems);
  // console.log("Menu items after filtering:", filteredMenuItems);
  // console.log("User permissions:", user_permissions);

  return filteredMenuItems;
};

export default Navdata;
